import { useState } from "react";
import { useChatDatabase } from "../../../lib/chatDatabase";
import { makeRequest } from "../../../utils/axios.js"; 

export const useChatAddUser = (onClose) => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { startNewChat } = useChatDatabase();

    const handleSearch = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const queryName = formData.get("username");

        if (!queryName) return;

        setIsLoading(true);
        setUsers([]);

        try {
            const res = await makeRequest.get("/friendships/search?name=" + queryName);
            setUsers(res.data);
        } catch (err) {
            console.error("Error when searching for a user:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = (selectedUser) => {
        if (!selectedUser) return;
        startNewChat(selectedUser);
        if (onClose) onClose(); 
    };

    return {
        users,
        isLoading,
        handleSearch,
        handleAdd
    };
};